import React, { Component } from 'react';
import {Row, Col} from 'react-materialize';
import ImageZoom from 'react-medium-image-zoom';
import '../css/gallery.css';

import photo_1 from '../img/gallery/photo_1.jpg';
import photo_2 from '../img/gallery/photo_2.jpg';
import photo_3 from '../img/gallery/photo_3.jpg';
import photo_4 from '../img/gallery/photo_4.jpg';
import photo_5 from '../img/gallery/photo_5.jpg';
import photo_6 from '../img/gallery/photo_6.jpg';
import photo_7 from '../img/gallery/photo_7.jpg';
import photo_8 from '../img/gallery/photo_8.jpg';
import photo_9 from '../img/gallery/photo_9.jpg';
import photo_10 from '../img/gallery/photo_10.jpg';
import photo_11 from '../img/gallery/photo_11.jpg';
import photo_12 from '../img/gallery/photo_12.jpg';
import photo_13 from '../img/gallery/photo_13.jpg';
import photo_14 from '../img/gallery/photo_14.jpg';
import photo_15 from '../img/gallery/photo_15.jpg';
import photo_16 from '../img/gallery/photo_16.jpg';
import photo_17 from '../img/gallery/photo_17.jpg';
import photo_18 from '../img/gallery/photo_18.jpg';

class Gallery extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return(
      <div className="photo">
        <Row>

          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_1,
                alt: 'Photo 1',
                className: 'img'
              }}
              zoomImage={{
                src: photo_1,
                className: 'img-zoom'
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_2,
                alt: 'Photo 2',
                className: 'img'
              }}
              zoomImage={{
                src: photo_2
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_3,
                alt: 'Photo 3',
                className: 'img'
              }}
              zoomImage={{
                src: photo_3
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_4,
                alt: 'Photo 4',
                className: 'img'
              }}
              zoomImage={{
                src: photo_4
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_5,
                alt: 'Photo 5',
                className: 'img'
              }}
              zoomImage={{
                src: photo_5
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_6,
                alt: 'Photo 6',
                className: 'img'
              }}
              zoomImage={{
                src: photo_6
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_7,
                alt: 'Photo 7',
                className: 'img'
              }}
              zoomImage={{
                src: photo_7
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_8,
                alt: 'Photo 8',
                className: 'img'
              }}
              zoomImage={{
                src: photo_8
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_9,
                alt: 'Photo 9',
                className: 'img'
              }}
              zoomImage={{
                src: photo_9
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_10,
                alt: 'Photo 10',
                className: 'img'
              }}
              zoomImage={{
                src: photo_10
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_11,
                alt: 'Photo 11',
                className: 'img'
              }}
              zoomImage={{
                src: photo_11
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_12,
                alt: 'Photo 12',
                className: 'img'
              }}
              zoomImage={{
                src: photo_12
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_13,
                alt: 'Photo 13',
                className: 'img'
              }}
              zoomImage={{
                src: photo_13
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_14,
                alt: 'Photo 14',
                className: 'img'
              }}
              zoomImage={{
                src: photo_14
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_15,
                alt: 'Photo 15',
                className: 'img'
              }}
              zoomImage={{
                src: photo_15
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_16,
                alt: 'Photo 16',
                className: 'img'
              }}
              zoomImage={{
                src: photo_16
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_17,
                alt: 'Photo 17',
                className: 'img'
              }}
              zoomImage={{
                src: photo_17
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
          <Col s={12} m={6} l={4}>
            <ImageZoom
              image={{
                src: photo_18,
                alt: 'Photo 18',
                className: 'img'
              }}
              zoomImage={{
                src: photo_18
              }}
              defaultStyles={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }
              }}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/gallery.js